export default __webpack_public_path__ + "odds-customize.svg";